package com.nonopn.skywatcher.common.app.portfolio.selected

import androidx.compose.foundation.background
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.AccountBox
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.icons.Administrator
import com.nonopn.icons.MapLocation
import com.nonopn.skywatcher.common.app.drawer.DrawerItem
import com.nonopn.skywatcher.common.app.drawer.DrawerSeparator
import com.nonopn.skywatcher.common.app.drawer.DrawerTitle
import com.nonopn.skywatcher.common.app.drawer.systemBackground
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.navigation.RouterAdministrators
import com.nonopn.skywatcher.common.app.navigation.RouterDetection
import com.nonopn.skywatcher.common.app.navigation.RouterUsers
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetection
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_section_admin_admins
import com.nonopn.skywatcher.common.app.res.menu_section_admin_users
import com.nonopn.skywatcher.common.app.res.menu_section_main_map
import com.nonopn.skywatcher.common.app.res.menu_title_admin
import com.nonopn.skywatcher.common.app.res.menu_title_main
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.utils.localized
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.theme.LocalDarkTheme
import eu.codlab.compose.widgets.spacers.BottomSpacer
import eu.codlab.compose.widgets.spacers.TopSpacer
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.RouteParameterTo

@Suppress("LongMethod", "UnusedPrivateMember")
@Composable
fun DrawerContentNormal(
    modifier: Modifier = Modifier,
    currentRoute: RouteParameterTo? = null,
    tiny: Boolean = false,
    currentThunderDetection: ThunderDetectionWithMetadata,
    onMenuItemSelected: (title: String, navigateTo: NavigateTo) -> Unit
) {
    val dark = LocalDarkTheme.current

    println("showing tiny ? $tiny")
    Column(
        modifier = modifier
            .systemBackground()
            .verticalScroll(rememberScrollState())
            .background(
                color = if (dark) {
                    AppColor.BackgroundBlue
                } else {
                    AppColor.White
                }
            )
    ) {
        TopSpacer()

        if (!tiny) {
            DrawerTitle(text = Res.string.menu_title_main.localized())
        } else {
            // nothing
        }

        Res.string.menu_section_main_map.localized().let { text ->
            DrawerItem(
                text = text,
                currentRoute = currentRoute,
                router = RouterDetection,
                image = Icons.Rounded.MapLocation,
                onClick = {
                    onMenuItemSelected(
                        text,
                        RouterDetection.navigateTo(currentThunderDetection)
                    )
                },
                tiny = tiny
            )
        }

        DrawerSeparator(
            Modifier.padding(vertical = 16.dp)
        )

        if (!tiny) {
            DrawerTitle(text = Res.string.menu_title_admin.localized())
        } else {
            // nothing
        }

        Res.string.menu_section_admin_admins.localized().let { text ->
            DrawerItem(
                text = text,
                currentRoute = currentRoute,
                router = RouterAdministrators,
                image = Icons.Rounded.Administrator,
                onClick = {
                    onMenuItemSelected(
                        text,
                        RouterAdministrators.navigateTo(currentThunderDetection)
                    )
                },
                tiny = tiny
            )
        }

        Res.string.menu_section_admin_users.localized().let { text ->
            DrawerItem(
                text = text,
                currentRoute = currentRoute,
                router = RouterUsers,
                image = Icons.Rounded.AccountBox,
                onClick = {
                    onMenuItemSelected(
                        text,
                        RouterUsers.navigateTo(currentThunderDetection)
                    )
                },
                tiny = tiny
            )
        }

        DrawerSeparator(
            Modifier.padding(vertical = 16.dp)
        )

        Column(Modifier.weight(1.0f)) { }

        BottomSpacer()
    }
}

@HotPreview(widthDp = 300, heightDp = 900, darkMode = true)
@HotPreview(widthDp = 300, heightDp = 900, darkMode = false)
@Composable
private fun PreviewDrawerContent() {
    HotPreviewApp(
        isDarkTheme = isSystemInDarkTheme()
    ) {
        DrawerContentNormal(
            tiny = false,
            currentThunderDetection = ThunderDetection.fakes.first()
        ) { _, _ ->
            // nothing}
        }
    }
}
